import { postApi } from "../../../shared/api/postApi"
import type { ApiResult } from "../../../shared/types/common.types"
import type {
    ModuloCrearRequest,
    ModuloCrearResult,
    ModulosBuscarRequest,
    ModulosBuscarResult,
    ModuloDeleteRequest,
    ModuloMostrarRequest,
    ModuloMostrarResult,
    ModuloEditarRequest,
    ModuloSubirNivelRequest,
    ModuloSubirNivelResult,
} from "../types/modulos.types"

// Capa de datos del módulo `modulos`. Contratos de respuesta preservados 1:1.
// NOTA: `moduloCrear` conserva su mensaje de error legacy propio
// ("Error al registrar el usuario") — no se normaliza, para no cambiar la UI.

export const moduloCrear = (dataPOST: ModuloCrearRequest): Promise<ModuloCrearResult | undefined> =>
    postApi("api/modulo/AgregarModulo", dataPOST, (d) => ({ modulo: d.Nombre }), { modulo: "" }, "Error al registrar el usuario")

export const modulosBuscar = (dataPOST: ModulosBuscarRequest): Promise<ModulosBuscarResult | undefined> =>
    postApi("api/modulo/BuscarModulo", dataPOST, (d) => ({ modulos: d.resultado }), { modulos: [] })

export const moduloDelete = (dataPOST: ModuloDeleteRequest): Promise<ApiResult | undefined> =>
    postApi("api/modulo/EliminarModulo", dataPOST)

export const moduloMostrar = (dataPOST: ModuloMostrarRequest): Promise<ModuloMostrarResult | undefined> =>
    postApi("api/modulo/MostrarModulo", dataPOST, (d) => ({ modulo: d.resultado[0] }), { modulo: {} })

export const moduloEditar = (dataPOST: ModuloEditarRequest): Promise<ApiResult | undefined> =>
    postApi("api/modulo/EditarModulo", dataPOST)

export const moduloSubirNivel = (dataPOST: ModuloSubirNivelRequest): Promise<ModuloSubirNivelResult | undefined> =>
    postApi("api/modulo/subirModulo", dataPOST, (d) => ({ modulos: d.resultado }), { modulos: [] })
